import React, { useContext, useEffect, useState } from 'react'
import { CardBody, Card } from 'reactstrap';
import courseContext from '../../Helper/Courses';
import { LI, UL } from '../../AbstractElements';
import { getCourseNameFromCourseId, getFullCourseName } from '../../utils/course';
import { STUDENT_COURSE_CHANGE } from '../../Constant';
import DropdownHeader from './DropdownHeader';
import { ChevronDown } from 'react-feather';
import { useNavigate } from 'react-router-dom';

const CourseDropdown = ({ onChangeCourse, courseId, type, isSecondModule, data, isAttendance, isCertificate, isDashboard, isUser, setSelectCourse, selectCourse, loading, notAllCourses }) => {

  const { activeCourse, courses, setActiveCourse } = useContext(courseContext)
  const [showActiveCourses, setShowActiveCourses] = useState(true)
  const filteredCourses = courses?.filter((course) => (showActiveCourses ? course.isCurrent : course))
  const feeRefund = data?.isRefund
  const isStudentCourses = type === STUDENT_COURSE_CHANGE
  const navigate = useNavigate()
  useEffect(() => {
    if(notAllCourses) return;
    if(setSelectCourse) {
      setSelectCourse("All Courses");
    }
  }, []);

  const onChangeHandler = (course) => {
    if(loading) return;

    if (!isUser) {
      if (onChangeCourse) {
        onChangeCourse(course?.id, data)

      } else {
        setActiveCourse(course)
        const path = isAttendance
          ? `/attendance-management/${course?.id}`
          : isCertificate
          ? `/certificate-management/${course?.id}`
          : `/feemanagement/${course?.id}`;
        navigate(path);
      }
    } else {
      setSelectCourse(course?.id || "All Courses");
      if(course?.id) setActiveCourse(course);
    }
  }

  const getDropBtnLabel = () => {
    if (isStudentCourses) {
      return getCourseNameFromCourseId(courses, courseId)
    }
    if(isDashboard && selectCourse === "All Courses"){
      return "All Active Courses";
    }
    if (!selectCourse || selectCourse === "All Courses") {
      return "All Courses";
    }
    const selected = courses.find(course => course.id === selectCourse);
    return selected ? getFullCourseName(selected) : "All Courses";
  };

  return (
    <div>
      <Card className={`basic-dropdown m-b-0 course-selection-card ${loading && 'disabled'}`}>
        <CardBody className={feeRefund && 'fee-refunded-disabled'}>
          <UL attrUL={{ className: 'd-flex flex-row flex-wrap' }}>
            <LI attrLI={{ className: feeRefund ? '' : 'onhover-dropdown' }}>
              <span className={`f-w-600 nowrap ${loading && 'disabled-text'}`}>{getDropBtnLabel()}</span>
              <span>
                <ChevronDown className='ms-2 middle' />
              </span>
              <UL attrUL={{ className: `onhover-show-div course-options  ${loading && 'disabled'}`, style: { maxHeight: '300px', padding: "10px", overflowY: 'auto', width: '400px' }}}>
                {!(isStudentCourses || isDashboard) ? (
                  <DropdownHeader
                    checked={showActiveCourses}
                    setChecked={setShowActiveCourses}
                    label={showActiveCourses ? 'Active Courses' : 'Full Courses'}
                  />) : ''}
                  {isDashboard && !notAllCourses &&
                  <LI attrLI={{ onClick: onChangeHandler }}>
                    <p className='m-0'>All Active Courses</p>
                  </LI>}
                {filteredCourses.map((course) => (
                  <LI key={course.id} attrLI={{ onClick: () => loading || onChangeHandler(course) }}>
                    <p className='m-0'> {getFullCourseName(course)}{isSecondModule ? ' Module 2' : ''}</p>
                  </LI>
                ))}
              </UL>
            </LI>
          </UL>
        </CardBody>
      </Card>
    </div>
  )
}

export default CourseDropdown
